import {
  DEFAULT_PROJECTION_DIMENSION_SETTING,
  IProjectionSetting,
  NodeTypeDefaultValueMap,
} from '@do-lib/global-interface';
import { staticImplements } from '../../interface_plugin';
import { AbstractDefaultProjectionSettingConfigProvider } from './abstract_default_projection_setting_config_provider';
import { applyUnitViewCurvesVisibilityDefault } from './unit_projection_default_overrides';
import { cloneDeep } from 'lodash-es';

/**
 * 宇通品系默认配置获取插件
 * 为宇通品系提供各种功能的默认初始配置
 */
@staticImplements()
export class DefaultProjectionSettingConfigProviderYutong extends AbstractDefaultProjectionSettingConfigProvider {
  static description = '宇通品系默认配置获取插件,';

  // 标注配置 https://designorder.yuque.com/bsy5gt/fn37z0/fzevodv060e4gf7b#BZGAn
  protected static _getNodeTypeDefaultValueMap(): typeof NodeTypeDefaultValueMap {
    const nodeTypeDefaultValueMap = cloneDeep(NodeTypeDefaultValueMap);

    for (const nodeTypeKey in nodeTypeDefaultValueMap) {
      const nodeTypeSettings = nodeTypeDefaultValueMap[nodeTypeKey];
      for (const projectTypeKey in nodeTypeSettings) {
        const config = nodeTypeSettings[projectTypeKey] as IProjectionSetting;

        config.dimensionSetting = {
          ...(config.dimensionSetting ?? DEFAULT_PROJECTION_DIMENSION_SETTING),
          chamferLocation: false,
          chamferAngle: true,
          parallelFace: false,
        };
      }
    }

    applyUnitViewCurvesVisibilityDefault(nodeTypeDefaultValueMap);
    return nodeTypeDefaultValueMap;
  }
}
